import { render, staticRenderFns } from "./SimpleCalendar.vue?vue&type=template&id=1579d3e4"
import script from "./SimpleCalendar.vue?vue&type=script&lang=js"
export * from "./SimpleCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports